import React, { useEffect, useState } from "react";
import axios from "axios";
import { useVipStore } from "../context/VipContext";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function User_VipDetailDutyHistory() {
  const { selectedVip } = useVipStore();
  const [expandedDutyId, setExpandedDutyId] = useState(null);

  const [allData, setAllData] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 20;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (selectedVip?.id) {
      fetchDutyHistory(selectedVip.id);
      return;
    }

    const storedVip = localStorage.getItem("selectedVip");
    if (storedVip) {
      const vipObj = JSON.parse(storedVip);
      if (vipObj?.id) {
        fetchDutyHistory(vipObj.id);
      }
    }
  }, []);

  const fetchDutyHistory = async (vipId) => {
    try {
      setLoading(true);
      const role = localStorage.getItem("role");
      const token = localStorage.getItem(`${role}Token`);

      if (!token) {
        console.error("Auth token missing");
        setAllData([]);
        return;
      }

      const res = await axios.get(
        `${BASE_URL}/api/assignments/vip/${vipId}/history`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const data = res.data;
      if (Array.isArray(data)) {
        setAllData(data);
      } else if (data && typeof data === "object") {
        setAllData([data]);
      } else {
        setAllData([]);
      }
    } catch (err) {
      console.log("VIP Duty History Error:", err);
      setAllData([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = allData.filter((item) =>
    `
    ${item.id || ""}
    ${item.category?.name || ""}
    ${item.category?.designation || ""}
    
${item.officers?.map(o => o.name).join(" ") || ""}
${item.officers?.map(o => o.rank).join(" ") || ""}
    ${item.status || ""}
    `
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + rowsPerPage);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleString();
  };

  const toggleExpand = (id) => {
    setExpandedDutyId(expandedDutyId === id ? null : id);
  };

  return (
    <div className="viphistory-wrapper">
      {/* Header */}
      <header className="viphistory-header">
        <h1>
          <i className="fas fa-history"></i> VIP Duty History
        </h1>
        <p>Complete record of past and current security assignments</p>
      </header>

      {/* Main Content */}
      <main className="viphistory-main">
        {/* Search Bar */}
        <div className="search-bar">
          <i className="fas fa-search"></i>
          <input
            type="text"
            placeholder="Search by duty ID, officer name, rank, status..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        {/* Table Card */}
        <div className="table-card">
          {loading ? (
            <div className="loading-state">
              <i className="fas fa-spinner fa-spin"></i>
              <p>Loading duty history...</p>
            </div>
          ) : paginatedData.length === 0 ? (
            <div className="empty-state">
              <i className="fas fa-folder-open fa-3x"></i>
              <h3>No Duty History Found</h3>
              <p>{search ? "No results match your search." : "This VIP has no recorded duty history yet."}</p>
            </div>
          ) : (
            <>
              {/* Desktop Table View */}
              <div className="desktop-table">
                <table className="history-table">
                  <thead>
                    <tr>
                      <th>Duty ID</th>
                      <th>Assigned At</th>
                      <th>Status</th>
                      <th>Officers ({paginatedData.reduce((acc, item) => {

                        const officers = Array.isArray(item.officers)
                          ? item.officers
                          : item.officers ? [item.officers] : [];

                        return acc + officers.length;
                      }, 0)})</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((item) => {

                      const officers = Array.isArray(item.officers)
                        ? item.officers
                        : item.officers ? [item.officers] : [];

                      const isExpanded = expandedDutyId === item.id;

                      return (
                        <React.Fragment key={item.id}>
                          <tr
                            className={`main-row ${isExpanded ? "expanded" : ""}`}
                            onClick={() => toggleExpand(item.id)}
                          >
                            <td>
                              <strong>{item.id}</strong>
                            </td>
                            <td>{formatDate(item.assignedAt)}</td>
                            <td>
                              <span
                                className={`status-badge ${item.status === "Active" ? "active" : "inactive"}`}
                              >
                                {item.status}
                              </span>
                            </td>
                            <td>
                              <span className="officer-count">
                                {officers.length} Officer{officers.length !== 1 ? "s" : ""}
                                <i className={`fas fa-chevron-${isExpanded ? "up" : "down"} expand-icon`}></i>
                              </span>
                            </td>
                          </tr>

                          {isExpanded && (
                            <tr className="expanded-details">
                              <td colSpan={4}>
                                <div className="nested-table-container">
                                  <table className="nested-table">
                                    <thead>
                                      <tr>
                                        <th>Officer Name</th>
                                        <th>Rank</th>
                                        <th>Start At</th>
                                        <th>End At</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {officers.length === 0 ? (
                                        <tr>
                                          <td colSpan={4} className="no-officer">
                                            No officers assigned for this duty
                                          </td>
                                        </tr>
                                      ) : (
                                        officers.map((o) => (
                                          <tr key={o.id}>
                                            <td>{o.name || "N/A"}</td>
                                            <td>
                                              <span className="rank-badge">{o.rank || "N/A"}</span>
                                            </td>
                                            <td>{formatDate(item.startAt)}</td>
                                            <td>{formatDate(item.endAt)}</td>
                                          </tr>
                                        ))
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Mobile Accordion View */}
              <div className="mobile-accordion">
                {paginatedData.map((item) => {

                  const officers = Array.isArray(item.officers)
                    ? item.officers
                    : item.officers ? [item.officers] : [];
                  const isExpanded = expandedDutyId === item.id;

                  return (
                    <div
                      key={item.id}
                      className={`accordion-item ${isExpanded ? "expanded" : ""}`}
                      onClick={() => toggleExpand(item.id)}
                    >
                      <div className="accordion-header">
                        <div className="header-info">
                          <strong>Duty #{item.id}</strong>
                          <span className={`status-badge ${item.status === "Active" ? "active" : "inactive"}`}>
                            {item.status}
                          </span>
                        </div>
                        <div className="header-meta">
                          <span>{formatDate(item.assignedAt)}</span>
                          <i className={`fas fa-chevron-${isExpanded ? "up" : "down"}`}></i>
                        </div>
                      </div>

                      {isExpanded && (
                        <div className="accordion-body">
                          <div className="officer-list">
                            {officers.length === 0 ? (
                              <p className="no-officer">No officers assigned</p>
                            ) : (
                              officers.map((o) => (
                                <div key={o.id} className="officer-card">
                                  <div className="officer-name">
                                    <i className="fas fa-user-shield"></i> {o.name}
                                  </div>
                                  <div className="officer-details">
                                    <span><strong>Rank:</strong> <span className="rank-badge">{o.rank}</span></span>
                                    <span><strong>Start:</strong> {formatDate(item.startAt)}</span>
                                    <span><strong>End:</strong> {formatDate(item.endAt)}</span>
                                  </div>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="pagination">
                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i}
                      className={currentPage === i + 1 ? "active" : ""}
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </main>

      <style jsx>{`
        .viphistory-wrapper {
          min-height: 100vh;
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
          color: #e2e8f0;
          padding: 2rem 1rem;
        }

        .viphistory-header {
          text-align: center;
          margin-bottom: 2.5rem;
        }

        .viphistory-header h1 {
          font-size: 2.4rem;
          font-weight: 700;
          color: #60a5fa;
          margin: 0 0 0.8rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.8rem;
        }

        .viphistory-header p {
          opacity: 0.85;
          font-size: 1.1rem;
        }

        .viphistory-main {
          max-width: 1200px;
          margin: 0 auto;
        }

        .search-bar {
          position: relative;
          margin-bottom: 2rem;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
        }

        .search-bar i {
          position: absolute;
          left: 1.2rem;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 1.2rem;
        }

        .search-bar input {
          width: 100%;
          padding: 1rem 1rem 1rem 3rem;
          border-radius: 16px;
          border: 1px solid rgba(59, 130, 246, 0.5);
          background: rgba(15, 23, 42, 0.8);
          color: #e2e8f0;
          font-size: 1.1rem;
        }

        .search-bar input:focus {
          outline: none;
          border-color: #60a5fa;
          box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.2);
        }

        .table-card {
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(12px);
          border-radius: 20px;
          padding: 2rem;
          border: 1px solid rgba(59, 130, 246, 0.3);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        }

        /* Desktop Table */
        .desktop-table {
          overflow-x: auto;
          border-radius: 16px;
          margin-bottom: 2rem;
        }

        .history-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
        }

        .history-table th {
          background: rgba(15, 23, 42, 0.9);
          padding: 1.2rem 1rem;
          text-align: left;
          color: #60a5fa;
          font-weight: 600;
        }

        .history-table td {
          padding: 1.2rem 1rem;
          border-bottom: 1px solid rgba(100, 116, 139, 0.3);
        }

        .main-row {
          cursor: pointer;
          transition: background 0.3s ease;
        }

        .main-row:hover {
          background: rgba(59, 130, 246, 0.1);
        }

        .main-row.expanded {
          background: rgba(59, 130, 246, 0.15);
        }

        .officer-count {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          font-weight: 600;
        }

        .expand-icon {
          font-size: 1rem;
          color: #60a5fa;
          transition: transform 0.3s ease;
        }

        .expanded-details td {
          padding: 0;
        }

        .nested-table-container {
          padding: 1.5rem;
          background: rgba(15, 23, 42, 0.6);
        }

        .nested-table {
          width: 100%;
          border-collapse: collapse;
        }

        .nested-table th {
          background: rgba(59, 130, 246, 0.2);
          padding: 1rem;
          text-align: left;
          color: #60a5fa;
          font-size: 0.95rem;
        }

        .nested-table td {
          padding: 1rem;
          border-bottom: 1px solid rgba(100, 116, 139, 0.2);
        }

        .no-officer {
          text-align: center;
          padding: 2rem;
          color: #94a3b8;
          font-style: italic;
        }

        /* Mobile Accordion */
        .mobile-accordion {
          display: none;
        }

        @media (max-width: 992px) {
          .desktop-table {
            display: none;
          }

          .mobile-accordion {
            display: flex;
            flex-direction: column;
            gap: 1rem;
          }

          .accordion-item {
            background: rgba(15, 23, 42, 0.8);
            border-radius: 16px;
            overflow: hidden;
            border: 1px solid rgba(59, 130, 246, 0.3);
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .accordion-item:hover {
            border-color: #60a5fa;
          }

          .accordion-header {
            padding: 1.5rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: rgba(59, 130, 246, 0.1);
          }

          .header-info {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
          }

          .header-info strong {
            font-size: 1.2rem;
          }

          .header-meta {
            display: flex;
            align-items: center;
            gap: 1rem;
            font-size: 0.95rem;
            opacity: 0.9;
          }

          .accordion-body {
            padding: 1.5rem;
            border-top: 1px solid rgba(100, 116, 139, 0.3);
          }

          .officer-list {
            display: flex;
            flex-direction: column;
            gap: 1rem;
          }

          .officer-card {
            background: rgba(30, 41, 59, 0.6);
            padding: 1.2rem;
            border-radius: 12px;
            border-left: 4px solid #3b82f6;
          }

          .officer-name {
            font-size: 1.1rem;
            font-weight: 600;
            margin-bottom: 0.8rem;
            display: flex;
            align-items: center;
            gap: 0.6rem;
            color: white;
          }

          .officer-details {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 0.6rem;
            font-size: 0.95rem;
          }

          .officer-details span {
            display: flex;
            flex-direction: column;
          }

          .officer-details strong {
            opacity: 0.8;
            font-size: 0.9rem;
          }
        }

        .status-badge {
          padding: 0.5rem 1rem;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
        }

        .status-badge.active {
          background: #10b98133;
          color: #10b981;
          border: 1px solid #10b981;
        }

        .status-badge.inactive {
          background: #ef444433;
          color: #ef4444;
          border: 1px solid #ef4444;
        }

        .rank-badge {
          background: #2563eb;
          color: white;
          padding: 0.4rem 0.8rem;
          border-radius: 30px;
          font-size: 0.9rem;
          font-weight: 600;
        }

        .loading-state,
        .empty-state {
          text-align: center;
          padding: 4rem 2rem;
        }

        .loading-state i {
          font-size: 3rem;
          color: #60a5fa;
          margin-bottom: 1rem;
          animation: spin 1.5s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .empty-state i {
          color: #94a3b8;
          margin-bottom: 1.5rem;
        }

        .empty-state h3 {
          font-size: 1.8rem;
          margin-bottom: 0.8rem;
        }

        .pagination {
          display: flex;
          justify-content: center;
          gap: 0.8rem;
          flex-wrap: wrap;
          margin-top: 2rem;
        }

        .pagination button {
          padding: 0.7rem 1.2rem;
          border-radius: 12px;
          border: 1px solid rgba(59, 130, 246, 0.5);
          background: rgba(15, 23, 42, 0.8);
          color: #e2e8f0;
          font-weight: 600;
          cursor: pointer;
        }

        .pagination button:hover {
          background: #2563eb;
          border-color: #60a5fa;
        }

        .pagination button.active {
          background: #3b82f6;
          color: white;
          box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.3);
        }

        @media (max-width: 768px) {
          .viphistory-header h1 {
            font-size: 2rem;
          }

          .table-card {
            padding: 1.5rem;
          }
        }

        @media (max-width: 576px) {
          .viphistory-wrapper {
            padding: 1rem;
          }

          .search-bar {
            margin: 0 0 2rem;
          }

          .officer-details {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
}



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useGuardStore } from "../context/GuardContext";
// import { useParams } from "react-router-dom";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// export default function User_OfficerDetailDutyHistroy() {
//   const { selectedGuard } = useGuardStore();

//   const [allData, setAllData] = useState([]);
//   const [search, setSearch] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 20;
//   const [loading, setLoading] = useState(true);
//   const { guardId } = useParams();

//   //  ALWAYS CALL API ON PAGE LOAD
//   useEffect(() => {
//     // 🔥 PRIORITY 1: URL PARAM
//     if (guardId) {
//       fetchDutyHistory(guardId);
//       return;
//     }

//     // 🔥 PRIORITY 2: CONTEXT
//     if (selectedGuard?.id) {
//       fetchDutyHistory(selectedGuard.id);
//       return;
//     }

//     // 🔥 PRIORITY 3: LOCAL STORAGE
//     const storedGuard = localStorage.getItem("selectedGuard");
//     if (storedGuard) {
//       const guardObj = JSON.parse(storedGuard);
//       if (guardObj?.id) {
//         fetchDutyHistory(guardObj.id);
//       }
//     }
//   }, [guardId]); // <-- eslint warns about this empty dependency

//   //  API CALL WITH TOKEN
//   const fetchDutyHistory = async (guardId) => {
//     try {
//       setLoading(true);

//       const role = localStorage.getItem("role");
//       const token = localStorage.getItem(`${role}Token`);
//       if (!token) {
//         console.error("❌ Auth token missing. role =", role);
//         setAllData([]);
//         return;
//       }

//       const res = await axios.get(
//         `${BASE_URL}/api/assignments/guard/${guardId}/history`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       setAllData(res.data || []);
//     } catch (err) {
//       console.log("Duty History Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   //  SEARCH FILTER (HANDLES NESTED FIELDS)
//   const filteredData = allData.filter((item) =>
//     `
//     ${item.id}
//     ${item.category?.name}
//     ${item.category?.designation}
//     ${item.officer?.name}
//     ${item.officer?.rank}
//     ${item.status}
//     `
//       .toLowerCase()
//       .includes(search.toLowerCase())
//   );

//   //  PAGINATION
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const paginatedData = filteredData.slice(
//     startIndex,
//     startIndex + rowsPerPage
//   );
//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);

//   //  DATE FORMATTER
//   const formatDate = (date) => {
//     if (!date) return "N/A";
//     return new Date(date).toLocaleString();
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.title}>Officer Duty History</div>

//       {/* 🔍 SEARCH */}
//       <div style={styles.filterRow}>
//         <div style={styles.filterCard}>
//           <div style={styles.filterLabel}>Search Duty</div>
//           <input
//             style={styles.select}
//             placeholder="Search by name, rank, status..."
//             value={search}
//             onChange={(e) => {
//               setSearch(e.target.value);
//               setCurrentPage(1);
//             }}
//           />
//         </div>
//       </div>

//       {/* 📋 TABLE */}
//       <div style={styles.card}>
//         {loading ? (
//           <div style={styles.noData}>Loading duty history...</div>
//         ) : paginatedData.length === 0 ? (
//           <div style={styles.noData}>No duty history found</div>
//         ) : (
//           <table style={styles.table}>
//             <thead>
//               <tr>
//                 <th style={styles.th}>Assignment ID</th>
//                 <th style={styles.th}>Vip Name</th>
//                 <th style={styles.th}>Designation</th>
//                 <th style={styles.th}>Start Time</th>
//                 <th style={styles.th}>End Time</th>
//                 <th style={styles.th}>Status</th>
//               </tr>
//             </thead>

//             <tbody>
//               {paginatedData.map((item, i) => (
//                 <tr key={i} style={styles.row}>
//                   <td style={styles.td}>{item.assignmentId}</td>
//                   <td style={styles.td}>{item.vipname || "N/A"}</td>
//                   <td style={styles.td}>{item.designation || "N/A"}</td>

//                   <td style={styles.td}>{formatDate(item.startTime)}</td>
//                   <td style={styles.td}>{formatDate(item.endTime)}</td>
//                   <td style={styles.td}>
//                     <span
//                       style={
//                         item.status === "Active"
//                           ? styles.statusActive
//                           : item.status === "Inactive"
//                           ? styles.statusInactive
//                           : styles.statusOther
//                       }
//                     >
//                       {item.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}

//         {/*  PAGINATION */}
//         {totalPages > 1 && (
//           <div style={styles.paginationContainer}>
//             {[...Array(totalPages)].map((_, i) => (
//               <button
//                 key={i}
//                 style={{
//                   ...styles.pageBtn,
//                   ...(currentPage === i + 1 ? styles.activePage : {}),
//                 }}
//                 onClick={() => setCurrentPage(i + 1)}
//               >
//                 {i + 1}
//               </button>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// /* ------------------ UI STYLES ------------------ */

// const styles = {
//   container: { padding: 30, background: "#fff" },
//   title: { fontSize: 30, fontWeight: 800, marginBottom: 25, color: "#1967d2" },

//   filterRow: { display: "flex", gap: 20, marginBottom: 25 },
//   filterCard: {
//     flex: 1,
//     padding: 18,
//     borderRadius: 12,
//     background: "#fff",
//     boxShadow: "0 3px 12px rgba(0,0,0,0.08)",
//   },
//   filterLabel: { fontSize: 15, fontWeight: 600, marginBottom: 6 },
//   select: {
//     width: "100%",
//     padding: "12px",
//     borderRadius: 8,
//     border: "1.5px solid #1a73e8",
//     fontSize: 15,
//   },

//   card: {
//     background: "#fff",
//     padding: 10,
//     borderRadius: 15,
//     boxShadow: "0 6px 25px rgba(0,0,0,0.1)",
//   },
//   table: { width: "100%", borderCollapse: "collapse" },
//   th: {
//     background: "#f4f4f6",
//     padding: "16px 10px",
//     textAlign: "left",
//     borderBottom: "2px solid #ddd",
//     fontWeight: 700,
//   },
//   row: { height: 62, transition: "0.25s", cursor: "pointer" },
//   td: { padding: "14px 10px", borderBottom: "1px solid #eee" },

//   statusActive: {
//     background: "#e6ffe6",
//     padding: "6px 12px",
//     borderRadius: 20,
//     color: "#2e7d32",
//     fontWeight: 600,
//   },
//   statusInactive: {
//     background: "#ffe6e6",
//     padding: "6px 12px",
//     borderRadius: 20,
//     color: "#d32f2f",
//     fontWeight: 600,
//   },
//   statusOther: {
//     background: "#fff8e1",
//     padding: "6px 12px",
//     borderRadius: 20,
//     color: "#ff9800",
//     fontWeight: 600,
//   },

//   noData: {
//     textAlign: "center",
//     padding: 40,
//     fontSize: 18,
//     color: "#777",
//   },

//   paginationContainer: {
//     display: "flex",
//     justifyContent: "center",
//     gap: 10,
//     padding: 15,
//   },
//   pageBtn: {
//     padding: "6px 14px",
//     borderRadius: 6,
//     border: "1px solid #1967d2",
//     background: "white",
//     cursor: "pointer",
//   },
//   activePage: {
//     background: "#1967d2",
//     color: "#fff",
//     fontWeight: 700,
//   },
// };
